export default __webpack_public_path__ + "static/illo-hearthands-ec83cef093ffc7f52b05d2064dfa7bc7.png";